(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  const widget = document.querySelector('recharge-subscription-widget');
  if (widget) widget.style.visibility = 'hidden';

  customElements.whenDefined('recharge-subscription-widget').then(() => {
    setTimeout(() => {
      const widget = document.querySelector('recharge-subscription-widget');
      
      if (!widget) {
        console.warn('Recharge widget not found');
        return;
      }

      // Benefits mutations
      const rcBenefits = widget.shadowRoot?.querySelector('rc-benefits');
      const ul = rcBenefits?.shadowRoot?.querySelector('ul');

      if (ul) {
        const firstLi = ul.querySelector('li:first-child p');
        if (firstLi && firstLi.textContent.trim() === 'Save 10%') {
          firstLi.textContent = 'Save 10% Every Time';
        }

        const newLi = document.createElement('li');
        const newP = document.createElement('p');
        newP.textContent = 'This is a recurring order';
        newLi.appendChild(newP);
        ul.insertBefore(newLi, ul.firstChild);
      }

      // 30-day default
      const rcPlans = widget.shadowRoot?.querySelector('rc-selling-plans');
      const plans = rcPlans?.shadowRoot?.querySelectorAll('input[type="radio"]');

      plans?.forEach(input => {
        if (input.getAttribute('aria-label')?.includes('30 days')) {
          input.click();
        }
      });

    if (widget) widget.style.visibility = 'visible';
    }, 500);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
